module.exports = __webpack_public_path__ + "imgs/archii-dark-light.svg";


//////////////////
// WEBPACK FOOTER
// ./apps/assets/img/archii-dark-light.svg
// module id = 550
// module chunks = 0